import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import Table from 'components/Table';
import StatusBadge from 'components/StatusBadge';
import Button from 'components/Button';
import CompanyActions from './CompanyActions';

import { companyTable as TEXT } from 'locales/en/client';
import { Link } from 'react-router-dom';

const CompanyTable = ({ data, header, ...rest }) => {
  const [activeItem, setActiveItem] = useState(null);
  const toggleActiveItem = (id) => {
    if (activeItem === id) {
      setActiveItem(null);
    } else {
      setActiveItem(id);
    }
  };

  return (
    <>
      {header}
      <Table
        titles={[
          TEXT.id,
          TEXT.name,
          TEXT.status,
          TEXT.merchantId,
          TEXT.feeStructure,
          '',
        ]}
        hasData={!!data.length}
        gridClassName="grid-5-cols"
        emptyCustomView={
          <div className="col-span-full py-24 text-center text-javelin-gray-dark">
            <p className="mb-5 text-xl font-bold">{TEXT.empty}</p>
            <Button
              className="btn-secondary h-10 w-40 p-0 text-sm"
              title={TEXT.createCompany}
            />
          </div>
        }
        {...rest}
      >
        {data.map((item, idx) => {
          const dataIndexNumber = data.length - 1 === idx ? 'last' : idx;
          return (
            <Fragment key={item.id}>
              <span
                data-index-number={dataIndexNumber}
                className={`py-3 px-5 text-xs text-javelin-gray-dark underline`}
              >
                {item.id}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className={`py-3 px-5 text-xs text-javelin-gray-dark`}
              >
                {item.name}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="py-3 pl-5 text-xs text-javelin-gray-dark"
              >
                <StatusBadge
                  status={item.account_holder_status}
                  className="ml-0"
                />
              </span>
              <span
                data-index-number={dataIndexNumber}
                className={`py-3 px-5 text-xs text-javelin-gray-dark`}
              >
                {item.google_pay_merchant_id}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className={`py-3 px-5 text-xs text-javelin-gray-dark`}
              >
                {item.feeStructure?.data?.name ? (
                  <Link to={`/fee-structures/${item.feeStructure?.data?.id}`}>
                    <span className="underline">
                      {item.feeStructure?.data?.name}
                    </span>
                  </Link>
                ) : (
                  <span>-</span>
                )}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className={`relative py-3 pr-5 text-right text-xs text-javelin-gray-dark`}
              >
                <CompanyActions
                  onClickOpen={() => toggleActiveItem(item.id)}
                  isOpen={activeItem === item.id}
                  onClose={() => setActiveItem(null)}
                  companyId={item.id}
                  position={idx <= data.length - 4 ? 'bottom' : 'top'}
                />
              </span>
            </Fragment>
          );
        })}
      </Table>
    </>
  );
};

CompanyTable.propTypes = {
  data: PropTypes.array,
};
CompanyTable.defaultProps = {
  data: [],
};
export default CompanyTable;
